import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  TaskCommentRequest,
  TaskCommentResponse,
  TaskCommentUpdateRequest,
  PageResponse
} from '../models/task.model';

@Injectable({ providedIn: 'root' })
export class TaskCommentApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) {}

  list(taskId: number): Observable<PageResponse<TaskCommentResponse>> {
    return this.http.get<PageResponse<TaskCommentResponse>>(`${this.apiUrl}/tasks/${taskId}/comments`);
  }

  create(taskId: number, req: TaskCommentRequest): Observable<TaskCommentResponse> {
    return this.http.post<TaskCommentResponse>(`${this.apiUrl}/tasks/${taskId}/comments`, req);
  }

  update(taskId: number, commentId: number, req: TaskCommentUpdateRequest): Observable<TaskCommentResponse> {
    return this.http.put<TaskCommentResponse>(
      `${this.apiUrl}/tasks/${taskId}/comments/${commentId}`,
      req
    );
  }

  delete(taskId: number, commentId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/tasks/${taskId}/comments/${commentId}`);
  }
}
